/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { editPermissionSchemePageResource } from '@jira/router-resources__admin-pages-permissions/src/editPermissionSchemePageResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsEditPermissionSchemesRoute } from '@jira/router-routes__admin-pages-permission-schemes-routes/src/globalSettingsEditPermissionSchemesRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import EditPermissionSchemePage, {
	LazyEditPermissionSchemePage,
} from './ui/spa/admin-pages/permission-schemes/edit-permission-scheme-page/index.tsx';

export const globalSettingsEditPermissionSchemesRouteEntry: Route = createEntry(
	globalSettingsEditPermissionSchemesRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.configure-permission-scheme',
		// eslint-disable-next-line no-restricted-syntax
		component: EditPermissionSchemePage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			editPermissionSchemePageResource,
		],

		canTransitionIn: () => true,
		forPaint: [LazyAtlassianNavigation, LazyEditPermissionSchemePage],

		meta: {
			reporting: {
				id: 'EditPermissionScheme',
				packageName: 'jiraAdminPagesEditPermissionScheme',
				teamName: 'gordian',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
